import { Grid } from '@mui/material';
import type { FC, MouseEvent as ReactMouseEvent } from 'react';
import { useNavigate } from 'react-router';

import { useZustand } from '../../zustandStore';

import { CookieDescription } from './cookieDescription';
import { CookieOptions } from './cookieOptions';

export const CookieManagement: FC = () => {
	const { cookies, setIsCookieCutterOpen, togglePreferences, toggleStatistics, toggleMarketing } = useZustand(
		state => ({ ...state }),
	);

	const { preferences, statistics, marketing } = cookies;
	const navigate = useNavigate();

	const handleCookieNoticeClick = (e: ReactMouseEvent) => {
		e.preventDefault();
		setIsCookieCutterOpen(false);
		void navigate('/cookie-notice');
	};

	return (
		<Grid container spacing={2}>
			<Grid size={12}>
				<CookieDescription handleCookieNoticeClick={handleCookieNoticeClick} />
				<CookieOptions
					preferences={preferences}
					statistics={statistics}
					marketing={marketing}
					togglePreferences={togglePreferences}
					toggleStatistics={toggleStatistics}
					toggleMarketing={toggleMarketing}
					handleCookieNoticeClick={handleCookieNoticeClick}
				/>
			</Grid>
		</Grid>
	);
};
